import React from 'react';
import './Header.css';
import backgroundImage from '../images/hero.svg'; 

const Hero = () => {
  return (
    <section
      className="hero"
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      <div className="overlay">
        <h1 className="hero-title">
          S.E.I TECHINTERNATIONAL <br /> FIRE RISK ASSESSMENT
        </h1>
      </div>
    </section>
  );
};

export default Hero;
